import { Channel, Socket } from 'phoenix'
import { ReplaySubject, Subject } from 'rxjs'
import { getChatSocket } from './ChatSocket'

const messageBus = new ReplaySubject<{ type: string }>(50)
const controlBus = new Subject<{ action: string }>()
const unreadCountUpdated = new ReplaySubject<number>()
let socket: Socket
let channel: Channel
let unread = 0

const onChannelMessage = (msg: any) => {
  messageBus.next(msg)
  updateUnreadCount(msg)
}

const resetUnreadCount = () => {
  unread = 0
  unreadCountUpdated.next(unread)
}

const updateUnreadCount = (msg: any) => {
  if (!(msg.type === 'message' || msg.type === 'competition')) {
    return
  }
  const lastRead = localStorage.getItem('last_read_time') || 0
  if (msg.timestamp > lastRead) {
    unread++
  }
  unreadCountUpdated.next(unread)
}

const onControlMessage = (msg: any) => {
  controlBus.next(msg)
}

const sendMessage = (msg: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    channel
      .push('new_msg', msg, 10000)
      .receive('ok', (resp) => resolve(resp))
      .receive('error', (err) => reject(err))
      .receive('timeout', () => reject('timeout'))
  })
}

const sendControlMessage = (msg: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    channel
      .push('control', msg, 10000)
      .receive('ok', (resp) => resolve(resp))
      .receive('error', (err) => reject(err))
      .receive('timeout', () => reject('timeout'))
  })
}

const joinChannel = () => {
  channel = socket.channel('room:lobby')
  channel.on('msg', onChannelMessage)
  channel.on('control', onControlMessage)
  channel.onClose(() => {
    // console.log('channel closed');
  })
  channel.onError((e) => {
    // console.log('channel error', e);
  })

  channel
    .join()
    .receive('ok', (resp) => {
      messageBus.next({ type: 'channel_join', msg: resp.nickname } as any)
    })
    .receive('error', (err) => messageBus.next({ type: 'error', msg: err } as any))
}

const init = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');

    if (undefined !== socket && !token) {
      messageBus.next({ type: 'onOpen' });
      joinChannel();
      resolve();
      return;
    }

    socket = getChatSocket();

    socket.onOpen(() => {
      messageBus.next({ type: 'onOpen' });
      joinChannel();
      resolve();
    });

    socket.onClose(() => {
      if (channel) {
        channel.leave();
      }
      messageBus.next({ type: 'onClose' });
      reject(new Error('Socket closed'));
    });

    socket.onError((err) => {
      reject(err);
    });
  });
};

export {
  init,
  messageBus,
  joinChannel,
  sendMessage,
  controlBus,
  sendControlMessage,
  resetUnreadCount,
  unreadCountUpdated,
}
